import "antd/es/form/style";
import _Form from "antd/es/form";
import "antd/es/input/style";
import _Input from "antd/es/input";
import "antd/es/select/style";
import _Select from "antd/es/select";
import "antd/es/date-picker/style";
import _DatePicker from "antd/es/date-picker";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { FilterItemType } from './types';
import "./index.css";
import MultiCascader from '../../MultiCascader';
var RangePicker = _DatePicker.RangePicker;
var Option = _Select.Option;
export * from './types';
export default (function (props) {
  var name = props.name,
      _props$label = props.label,
      label = _props$label === void 0 ? '' : _props$label,
      _props$type = props.type,
      type = _props$type === void 0 ? FilterItemType.Input : _props$type,
      selectOptions = props.selectOptions,
      extraProps = props.extraProps,
      _props$onValuesChange = props.onValuesChange,
      onValuesChange = _props$onValuesChange === void 0 ? function () {} : _props$onValuesChange,
      _props$extraFormItemP = props.extraFormItemProps,
      extraFormItemProps = _props$extraFormItemP === void 0 ? {} : _props$extraFormItemP,
      customFilterItem = props.customFilterItem;

  var _useState = useState(selectOptions),
      _useState2 = _slicedToArray(_useState, 2),
      selectList = _useState2[0],
      setSelectList = _useState2[1];

  var getDefaultPlaceholder = function getDefaultPlaceholder(thisType, label) {
    switch (thisType) {
      case FilterItemType.Input:
        {
          return label;
        }

      case FilterItemType.Select:
        {
          return 'All';
        }

      default:
        return '';
    }
  };

  var disabledDate = function disabledDate(current) {
    var result = false;

    if (current > moment().add(0, 'days')) {
      result = true;
    }

    return result;
  }; // 递归将 SelectOptions 转成 TreeNode


  var convertSelectOptionsToTreeNode = function convertSelectOptionsToTreeNode(selectOptions) {
    if (!selectOptions) return [];
    var treeNodes = selectOptions.map(function (selectOption) {
      var treeNode = {
        key: String(selectOption.value),
        title: String(selectOption.label),
        value: String(selectOption.value)
      };

      if (selectOption.subOptions) {
        treeNode.children = convertSelectOptionsToTreeNode(selectOption.subOptions);
      }

      return treeNode;
    });
    return treeNodes;
  };

  var getFormItem = function getFormItem(label) {
    switch (type) {
      case FilterItemType.Input:
        {
          return /*#__PURE__*/React.createElement(_Input, _objectSpread({
            placeholder: getDefaultPlaceholder(FilterItemType.Input, label),
            onChange: function onChange(e) {
              return (//@ts-ignore
                onValuesChange(_defineProperty({}, name, e.target.value))
              );
            },
            allowClear: true
          }, extraProps));
        }

      case FilterItemType.Select:
        {
          return /*#__PURE__*/React.createElement(_Select, _objectSpread({
            placeholder: getDefaultPlaceholder(FilterItemType.Select, label),
            onSelect: function onSelect(options) {
              return onValuesChange(_defineProperty({}, name, options));
            },
            allowClear: true,
            showArrow: true
          }, extraProps), (selectList || []).map(function (item) {
            var value = item.value,
                label = item.label;
            return /*#__PURE__*/React.createElement(Option, {
              value: value,
              key: value
            }, typeof label === 'function' ? label(value, value) : label);
          }));
        }

      case FilterItemType.DatePicker:
        {
          return /*#__PURE__*/React.createElement(RangePicker // placeholder={getDefaultPlaceholder(FilterItemType.DatePicker)}
          , _objectSpread({
            // placeholder={getDefaultPlaceholder(FilterItemType.DatePicker)}
            onChange: function onChange(values) {
              return onValuesChange(_defineProperty({}, name, values));
            },
            className: "picker",
            disabledDate: disabledDate,
            showTime: {
              defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
            }
          }, extraProps));
        }

      case FilterItemType.MultiCascader:
        {
          return /*#__PURE__*/React.createElement(MultiCascader, _objectSpread({
            selectAll: true,
            allowClear: true,
            placeholder: "All",
            data: convertSelectOptionsToTreeNode(selectList)
          }, extraProps));
        }

      case FilterItemType.Custom:
        {
          return customFilterItem;
        }

      default:
        return null;
    }
  };

  useEffect(function () {
    setSelectList(selectOptions);
  }, [selectOptions]);
  return /*#__PURE__*/React.createElement(_Form.Item, _objectSpread({
    className: "biz-component-search-filter-form-item",
    name: name,
    label: label,
    labelAlign: "right",
    labelCol: {
      span: 3
    }
  }, extraFormItemProps), getFormItem(label));
});